<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="">
        <sui-diagram
          :model="diagramModel"
          :width="canvasWidth"
          :height="canvasHeight"
        />
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickClose"
      >
        {{ $t('MSG_BTN_CLOSE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';
// eslint-disable-next-line import/no-unresolved
import Diagram from '~common/components/form/SuiDiagram/components/SuiDiagram';

export default {
  name: 'PGE_CMR_00003_P02', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    workflowId: {
      type: String,
      default: null,
    },
    selectedRowData: {
      type: Object,
      default: null,
    },
    processTaskStandardIdInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      diagramModel: new Diagram.Model(),
      canvasWidth: 1150,
      canvasHeight: 400,
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [],
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.workflowId)) {
        this.selectDiagramData();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    selectDiagramData() {
      this.diagramModel = new Diagram.Model();
      http.request(this.pageId, 'DTS_CMR_00021', {
        path: { 'workflow-id': this.workflowId },
        query: {
          processTaskStandardId: '',
          canvasWidth: this.canvasWidth,
          canvasHeight: this.canvasHeight,
        },
      }).then(res => {
        console.log(res);
        const nodeMap = {};
        const { nodeList } = res.data;
        nodeList.forEach(node => {
          nodeMap[node.nodeId] = this.diagramModel.addNode(node.nodeName,
            node.posX,
            node.posY,
            node.width,
            node.height);
          nodeMap[node.nodeId].color = (node.processYn === 'Y') ? '#cc6666' : '#00cc66';
        });
        nodeList.forEach(node => {
          node.nextNodeId.forEach(nextNodeId => {
            this.diagramModel.addLink(nodeMap[node.nodeId].addOutPort(''), nodeMap[nextNodeId].addInPort(''));
          });
        });
      });
    },
    onClickClose() {
      this.$emit('popupClose');
    },
  },
};
</script>
<style scoped>
</style>
